import React, { FC } from 'react';
import { BKJButton, BKJIcon } from '@awais4123/fillify-design-library';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { Flex } from 'components/Flex';

import {
  CSVBorderHeaderStyle,
  H3,
  TeamMemberCSVWrapper,
  LocationHeader,
  ContentName,
  LinkLine,
} from 'components/InviteTeamMembersByCSVModal/views/InviteTeamMemberView/views/InviteTeamMemberSuccessView/InviteTeamMemberSuccessView.styled';

import { inviteTeaMemberCSVModalRoutingService } from 'components/InviteTeamMembersByCSVModal/InviteTeamMembersByCSVModal.ui.context';
import { TeamMemberCSVViewFormProvider } from 'components/InviteTeamMembersByCSVModal/views/ImportViaSpreadsheet/TeamMemberCSVView.form.context';
import { useTranslation } from 'hooks/useTranslation';
export const Component: FC = () => {
  const { t } = useTranslation();
  return (
    <Flex
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      width="100%"
      flexGrow={1}
      borderTop={CSVBorderHeaderStyle}
    >
      <Flex flexDirection="column" padding="32px 40px 15px" gap="32px">
        <H3>{t('team_member:INVITE_SUCCESSFUL')}</H3>
        <TeamMemberCSVWrapper>
          <LocationHeader>
            {t('team_member:THE_TEAM_MEMBER_WILL_BE_NOTIFIED_BY_EMAIL_AND_TEXT')}
          </LocationHeader>
        </TeamMemberCSVWrapper>
        <Flex flexDirection="column" gap="8px">
          <Flex alignItems="center" gap="8px">
            <BKJIcon iconName="StepCheck" /> <ContentName>{t('team_member:INVITED')}</ContentName>
          </Flex>
          <LinkLine />
          <Flex alignItems="center" gap="8px">
            <BKJIcon iconName="StepCheck" />
            <ContentName>{t('team_member:START_SCHEDULING')}</ContentName>
          </Flex>
        </Flex>
      </Flex>

      <Flex height="100%"></Flex>
      <BKJSideModalFooter justifyContent="space-between" flexDirection="row-reverse">
        <BKJButton
          variant="PurpleSolid"
          width="180px"
          onClick={() => inviteTeaMemberCSVModalRoutingService.close()}
          type="button"
        >
          {t('team_member:DONE')}
        </BKJButton>
      </BKJSideModalFooter>
    </Flex>
  );
};
export const InviteTeamMemberSuccessView: FC = () => {
  return (
    <TeamMemberCSVViewFormProvider>
      <Component />
    </TeamMemberCSVViewFormProvider>
  );
};
